import React, { useContext, useEffect, useState } from 'react'
import LoggedInUi from './LoggedInUi'
import { makeAuthenticatedGETRequest } from '../utils/endPointCalling'
import ProfileCard from '../Components/Shared/ProfileCard';
import modalContext from '../context/ModalContext';

function Saved() {
    const [userData, setUserData] = useState([]);
    const {showModal, setShowModal} = useContext(modalContext);
    const {modalDetails, setModalDetails} = useContext(modalContext);
    useEffect(()=>{
        const getData = async () => {
            const response = await makeAuthenticatedGETRequest('/feature/get/saved');
            setUserData(response.data.saved);
        }
        getData();
    },[]);
  return (
    <LoggedInUi>
        <div className='text-black font-bold w-full h-[20%] flex justify-center my-[0.5vmax] items-center text-[3vmax]'>SAVED USERS</div>
        <div className='flex flex-wrap justify-center px-[2vmax] gap-[2vmax]'>
        {userData.length>0 && userData.map((item)=>{
            return <ProfileCard item={item} viewDetails={()=>{setShowModal(true);
                setModalDetails(item);
            }} />
        })}
        </div>
    </LoggedInUi>
  )
}

export default Saved